import { render } from "./navbar.vue?vue&type=template&id=0c71479b"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/test.rwandabuildprogram.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__